import React, { useState } from 'react'
import addmarket from './AddMarket.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'

import { useParams } from 'react-router-dom';

const AddMarket = () => {
    const { invId, channelId } = useParams();

    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()
    const location = useLocation()
    const data = location.state
    console.log(data)

    const navigate = useNavigate()

    const inputRef = React.useRef();

    const [file, setFile] = useState(null)
    const [marketData, setmarketData] = useState({
        graphName: '',
        graphDesc: '',
    })
    const [source, setSource] = React.useState();
    const [fileName, setFileName] = React.useState('');
    const [imageSelect, setImageSelect] = useState(false)

    const handleInputChange = (event) => {
        const { name, value } = event.target
        setmarketData({ ...marketData, [name]: value })
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFileName(file.name)
        const url = URL.createObjectURL(file);
        setSource(url);
        setImageSelect(true)
        setFile(file)
    };

    const handleChoose = (event) => {
        inputRef.current.click();
    };

    const discardImage = (event) => {
        setSource(null)
        setFileName('')
        setFile(null)
        inputRef.current.value = ""
        setImageSelect(false)
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        const formDataObj = new FormData()
        formDataObj.append("file", file)
        formDataObj.append("graphName", marketData.graphName)
        formDataObj.append("graphDesc", marketData.graphDesc)

        try {
            const graphResponse = await axios.post(
                `${process.env.REACT_APP_COSMOSINV}/graph/addGraph/${invId}/${channelId}`,
                marketData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            console.log(graphResponse)
            const imageResponse = await axios.post(
                `${process.env.REACT_APP_COSMOSINV}/graph/addGraphImage/${graphResponse.data.graphId}`,
                formDataObj,
                {
                    headers: {
                        "Content-Type": "image/jpeg"
                    }
                }
            )
            navigate(-1)
            alert('Graph Added.')
            

            dispatch(setNotificationCount({
                count: count + 1,
            }))

            discardImage()

        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className={addmarket.teammemberMain}>
            <div className={addmarket.teammemberContent}>
                <form action="" className={addmarket.teammemberForm} onSubmit={handleSubmit} encType='multipart/form-data'>
                    <label className={addmarket.teammemberFormLabel}>Name</label>
                    <input className={addmarket.teammemberFormText} type="text" value={marketData.graphName} name='graphName' onChange={handleInputChange} />

                    <label className={addmarket.teammemberFormLabel}>Description</label>
                    <textarea className={addmarket.teammemberFormDesc} value={marketData.graphDesc} name='graphDesc' onChange={handleInputChange} />
                    <label className={addmarket.teammemberFormLabel}>Upload</label>
                    <div className={addmarket.ImgInput}>
                        <input
                            ref={inputRef}
                            className={addmarket.ImgInput_input}
                            type="file"
                            onChange={handleFileChange}
                        />
                        {!source && <button type='button' onClick={handleChoose}>Browse</button>}
                        {source && (
                            <img
                                className={addmarket.ImgInput_img}
                                width="100%"
                                src={source}
                                alt='uploadedimage'
                            />
                        )}
                    </div>
                    <div className={addmarket.ImgInput_footer}>
                        {imageSelect ?
                            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                                {fileName}
                                <DeleteForeverOutlinedIcon onClick={discardImage} sx={{ cursor: 'pointer' }} />
                            </div> :
                            ''}
                    </div>
                    <Button variant='contained' type='submit' className={addmarket.saveChanges}>Save changes</Button>
                </form>
            </div>
        </div>
    )
}

export default AddMarket